// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/recoleta/Recoleta-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/recoleta/Recoleta-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/recoleta/Recoleta-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/recoleta/Recoleta-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/manrope/Manrope-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/manrope/Manrope-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/manrope/Manrope-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/manrope/Manrope-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fonts/museo/museo100.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fonts/museo/museo100.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/fonts/museo/museo300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("assets/fonts/museo/museo300.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("assets/fonts/museo/museo300italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("assets/fonts/museo/museo300italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("assets/fonts/museo/museo500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("assets/fonts/museo/museo500.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("assets/fonts/museo/museo500italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("assets/fonts/museo/museo500italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("assets/fonts/museo/museo700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("assets/fonts/museo/museo700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("assets/fonts/museo/museo900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("assets/fonts/museo/museo900.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Recoleta';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Recoleta';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
  font-weight: 600;
  font-style: normal;
}

/* NEW */
@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'Museo Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff');
  font-weight: 900;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./design-library/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB;;0DAEmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAEgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;;0DAEiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;;0DAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,QAAQ;AACR;EACE,yBAAyB;EACzB;;0DAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;;2DAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;;2DAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;;2DAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;;2DAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;;2DAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;;2DAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: 'Recoleta';\n  src:\n    url('assets/fonts/recoleta/Recoleta-Regular.woff2') format('woff2'),\n    url('assets/fonts/recoleta/Recoleta-Regular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Recoleta';\n  src:\n    url('assets/fonts/recoleta/Recoleta-Bold.woff2') format('woff2'),\n    url('assets/fonts/recoleta/Recoleta-Bold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Manrope';\n  src:\n    url('assets/fonts/manrope/Manrope-Regular.woff2') format('woff2'),\n    url('assets/fonts/manrope/Manrope-Regular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Manrope';\n  src:\n    url('assets/fonts/manrope/Manrope-Bold.woff2') format('woff2'),\n    url('assets/fonts/manrope/Manrope-Bold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n}\n\n/* NEW */\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo100.woff2') format('woff2'),\n    url('assets/fonts/museo/museo100.woff') format('woff');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo300.woff2') format('woff2'),\n    url('assets/fonts/museo/museo300.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo300italic.woff2') format('woff2'),\n    url('assets/fonts/museo/museo300italic.woff') format('woff');\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo500.woff2') format('woff2'),\n    url('assets/fonts/museo/museo500.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo500italic.woff2') format('woff2'),\n    url('assets/fonts/museo/museo500italic.woff') format('woff');\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo700.woff2') format('woff2'),\n    url('assets/fonts/museo/museo700.woff') format('woff');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Museo Sans';\n  src:\n    url('assets/fonts/museo/museo900.woff2') format('woff2'),\n    url('assets/fonts/museo/museo900.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
